export default function (cls) {
  /**
   * 会员登录
   *
   * @param mobile             {String}       登录手机号码
   * @param password           {String}       登录密码
   * @param mobile_code        {String}       国际区号
   * @returns {Promise<String>}               resolve(登录成功文言)
   */
  cls.prototype.login = async ({ mobile, code, mobile_code }) => {
    const response = await cls.request({
      method: 'post',
      url: '/account/login/captcha',
      data: { mobile, code, mobile_code }
    })
    // 登录成功，获取到用户登录凭证 token 之后
    if (response.code === 200) {
      // 存储 token 到 localStorage
      const tokenData = {
        value: response.results.token,
        expired: response.results.expired_timestamp
      }
      cls.saveTokenToLocalStorage(tokenData)
      // 挂载 token 到实例上
      cls.token = response.results.token
      return response
    } else {
      return response
    }
  }

  /**
   * 获取会员账户信息, 需要 token
   *
   * @returns {Promise<*>}      data.code // 200=成功
   */
  cls.prototype.fetchAccountProfile = async () => {
    const response = await cls.request({
      url: '/account/profile'
    })
    if (response.code === 200) {
      return response.results
    }
  }

  /**
   * 保存会员账户信息, 需要 token
   *
   * @param avatar {String} 头像
   * @param nickname {String} 昵称
   * @param gender {Integer} 性别
   * @param email {String} 邮箱
   * @returns {Promise<*>}      data.code // 200=成功
   */
  cls.prototype.updateAccountProfile = async ({avatar, nickname, gender, email}) => {
    const response = await cls.request({
      method: 'post',
      url: '/account/profile/save',
      data: {
        avatar,
        nickname,
        gender,
        email
      }
    })
    return response
  }

  /**
   * 会员实名认证, 需要 token
   *
   * @param realname {String} 真实姓名
   * @returns {Promise<*>}      data.code // 200=成功
   */
  cls.prototype.accountProfileAuthRealName = async ({ realname, identity_number }) => {
    const response = await cls.request({
      method: 'post',
      url: '/account/profile/auth/realname',
      data: {
        realname,
        identity_number
      }
    })
    return response
  }

  /**
   * 会员手机号码修改步骤1, 需要 token
   *
   * @param code {String} 验证码
   * @returns {Promise<*>}      data.code // 200=成功
   */
  cls.prototype.accountProfileResetMobileStep1 = async (code) => {
    const response = await cls.request({
      method: 'post',
      url: '/account/profile/reset/mobile/step1',
      data: {
        code
      }
    })
    return response
  }

  /**
   * 会员手机号码修改步骤2, 需要 token
   *
   * @param mobile {String} 手机号
   * @param code {String} 验证码
   * @param realname {String} 姓名
   * @param mobile_code {String} 国际区号
   * @returns {Promise<*>}
   */
  cls.prototype.accountProfileResetMobileStep2 = async ({mobile, code, realname, mobile_code}) => {
    const response = await cls.request({
      method: 'post',
      url: '/account/profile/reset/mobile/step2',
      data: {
        mobile,
        code,
        realname,
        mobile_code
      }
    })
    return response
  }

  /**
   * 退出登录
   * @returns {Promise<*>}
   */
  cls.prototype.logout = () => {
    return cls.request({
      url: '/account/logout'
    })
  }

  /**
   * 请求发送短信验证码
   * @param type               {Number}       验证码类型：201-注册，202-重置，203-重置手机1，204-重置手机2，205-实名认证，206-认领地图标记
   * @param mobile             {String}       手机号码
   * @returns                  {Promise<*>}
   */
  cls.prototype.fetchCode = ({ type = 207, mobile_full }) => {
    return cls.request({
      url: '/account/sms/code/${type}/${mobile_full}',
      params: { type, mobile_full }
    })
  }

  /**
   * 获取扫码登录的二维码
   * @returns {Promise<*>}
   */
  cls.prototype.fetchLoginQR = () => {
    return cls.request({
      url: '/account/login/qrcode/create'
    })
  }

  /**
   * 验证扫码登录结果, 需要 token
   * @returns {Promise<*>}      data.code // 200=成功，404=二维码过期，201=会员未执行扫码并确定登录，500=其他错误
   */
  cls.prototype.checkQRLogin = () => {
    return cls.request({
      url: '/account/login/qrcode'
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/member/api/initAuth.js